import React from "react";
import { Container, Row } from "reactstrap";


function Cuotas(){

    return (
        <>
        <Container className="mt-5" fluid>
              <Row className="mt-5">
                <h2>Hola Cuotas</h2>
              </Row>
        </Container>
        </>
    )
}


export default Cuotas;